import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { Text, Title } from '../../../components/presentation/Text'
import { useLocation } from '../../../utils/contexts/UrlProvider'
import { useShareForm } from './_context/ShareFormContext'
import Center from '../../../components/helpers/Center'
import Separator from '../../../components/helpers/Separator'
import ShareLink from '../../../components/presentation/ShareLink'
import { COLORS } from '@btime/constants'

const SharePublicForm = () => {
  const { t } = useTranslation('shareForm')
  const form = useShareForm()
  const { host } = useLocation()
  const shareLink = `${host}/m/forms/${form.shareCode}/execution`

  return (
    <Fragment>
      <Title size="h4" align="center">
        {form.name}
      </Title>

      <Center>
        <Text align="center" maxWidth={16}>
          {t('publicSubtitle')}
        </Text>
      </Center>

      <Separator weight={6} />
      <HorizontalLine thin lineColor={COLORS.light3} />
      <Separator weight={6} />

      <ShareLink label={t('shareLink')} url={shareLink} />
    </Fragment>
  )
}

export default SharePublicForm
